const version = '__@FLOPFLIP/VERSION_OF_RELEASE__';

export { adapter } from './adapter';
export { version };
